module.exports = __webpack_public_path__ + "static/mreis@1x-29156d6e66968d2c70f5b0396169cd4d.png";